import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { activateRoute, RouteEnabled } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useActivateRoute = (
  id: number,
  options: UseMutationOptions<RouteEnabled, unknown, void, unknown>
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => extractData(activateRoute({ path: { id } })),
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({
        queryKey: ['routes'],
      });
      options.onSuccess?.(...args);
    },
  });
};
